export const fmtRM = (n) =>
  `RM ${(Number(n) || 0).toLocaleString("ms-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtNum = (n) => (Number(n) || 0).toLocaleString("ms-MY");

export const fmtDate = (s) => {
  if (!s) return "-";
  try {
    return new Date(s).toLocaleDateString("ms-MY", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return s;
  }
};
